/* This example requires Tailwind CSS v2.0+ */
import { StepperProps } from "components/organisms/Stepper";
import tw from "twin.macro";

export const VerticalStepper = ({
  steps,
  className,
}: Omit<StepperProps, "currentStep" | "vertical">) => {
  return (
    <nav aria-label="Progress" className={className}>
      <ol role="list" tw="overflow-hidden">
        {steps?.map((step, stepIdx) => (
          <li
            key={step.title}
            tw="relative"
            css={stepIdx !== steps.length - 1 && tw`pb-10`}
          >
            {stepIdx !== steps.length - 1 ? (
              <div
                tw="absolute top-4 left-[30px] mt-0.5 -ml-px h-full bg-black w-[1px]"
                aria-hidden="true"
              />
            ) : null}
            <div tw="flex relative items-center">
              <div tw="flex-center" aria-hidden="true">
                <span tw="flex relative z-10 justify-center items-center w-[60px] h-[60px] bg-white rounded-full border border-black border-solid">
                  {step.icon}
                </span>
              </div>
              <span tw="flex flex-col ml-4 min-w-0">
                <span tw="font-semibold text-sm leading-none text-black">
                  {step.title}
                </span>
                <span tw="font-light text-xs leading-4 text-black mt-1">
                  {step.description}
                </span>
              </span>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
};
